import Dialog from '@rio-cloud/rio-uikit/Dialog';
import moment from 'moment';
import { FormattedDate, FormattedMessage } from 'react-intl';

import ReleaseImage from '../static/release-6.2.0-imperial.png';
import newLogo from '../static/release-new.png';

type DateProps = Pick<Intl.DateTimeFormatOptions, 'day' | 'month' | 'year'>;

const dateProps = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
};

type ReleaseI = Record<string, { content: JSX.Element[]; date: string; featureName?: string }>;

const getReleases = (releaseNotes: ReleaseI) => {
    const releases: JSX.Element[] = [];
    Object.entries(releaseNotes).forEach(([version, note]) => {
        const notePoints = note.content.map((point: JSX.Element, i: number) => (
            <li style={{ listStyle: 'none' }} key={`${version}-${releaseNotes}-note-${i}`}>
                {point}
            </li>
        ));

        const featureName = note && note.featureName;

        releases.push(
            <div className={'form-group'} key={`${version}-${releaseNotes}-note`}>
                <div className="display-flex">
                    <h5 className="margin-right-10 white-space-nowrap">{`v ${version}`}</h5>
                    <div className="display-flex width-100pct justify-content-between">
                        <h5>{featureName && <span className=" word-break">{featureName}</span>}</h5>
                        <h5 className="pull-right text-muted margin-left-15">
                            <FormattedDate
                                value={moment(note.date, moment.ISO_8601).toDate()}
                                {...(dateProps as DateProps)}
                            />
                        </h5>
                    </div>
                </div>
                <ul className="padding-left-0 margin-bottom-0">{notePoints}</ul>
            </div>
        );
    });

    return releases;
};

function ChangelogDialog({ toggleChangeDialog, show }: { toggleChangeDialog: () => void; show: boolean }) {
    // const intl = useIntl();
    const header = <FormattedMessage id="releaseNotes.whatsNew" defaultMessage="Changelog" />;

    const releaseNotes = {
        '6.2.0': {
            date: '2026-06-18T00:00:00',
            content: [
                <div key="releaseNotes.6.2.0">
                    <div className="display-flex align-items-center">
                        <img alt="new-logo" src={newLogo} style={{ width: '80px', objectFit: 'contain' }} />
                    </div>
                    <div className="display-flex margin-top-15 flex-column">
                        <div>
                            <p className="margin-0 margin-top-5">
                                <FormattedMessage id="help.changelog.6.2.0.featurePrologue" />
                            </p>
                            <hr></hr>
                        </div>
                        <div className="display-flex">
                            <div className="display-flex flex-column width-100pct">
                                <p className="text-bold margin-0">
                                    <FormattedMessage id="help.changelog.6.2.0.releaseTitle" />
                                </p>
                            </div>
                        </div>
                        <div className="display-flex">
                            <div className="flex-basis-40pct">
                                <ul style={{ listStyleType: 'disc' }}>
                                    <li className="margin-bottom-10">
                                        <FormattedMessage id="help.changelog.6.2.0.releaseDetail.one" />
                                    </li>
                                    <li className="margin-bottom-10">
                                        <FormattedMessage id="help.changelog.6.2.0.releaseDetail.two" />
                                    </li>
                                    <li>
                                        <FormattedMessage id="help.changelog.6.2.0.releaseDetail.three" />
                                    </li>
                                </ul>
                            </div>
                            <div className="flex-basis-60pct">
                                <img
                                    alt="release-image"
                                    src={ReleaseImage}
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>,
            ],
        },
    };

    const body = <div>{getReleases(releaseNotes)}</div>;

    const footer = (
        <button data-component="CloseButton" type="button" className="btn btn-default" onClick={toggleChangeDialog}>
            <FormattedMessage id="close" defaultMessage="Close" />
        </button>
    );
    return (
        <Dialog show={show} title={header} body={body} onHide={toggleChangeDialog} useOverflow={true} footer={footer} />
    );
}

export default ChangelogDialog;
